import { proxyClientOptions, RestfulClient, Session, StockSymbol } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { DelayedQuote } from '../../entities';
import { QuotesEnvironment } from '../../environment';
import { quotesDelayedRoutes } from './routes';
import { QuotesDelayedTransport } from './types';

export class QuotesDelayedRestful extends RestfulClient implements QuotesDelayedTransport {
  constructor(session: Session) {
    const env = session.getEnvironment(QuotesEnvironment);
    super(env.delayedQuoteUrl, session, { 'x-device-key': true }, proxyClientOptions(undefined, 'apikey'));
  }

  getDelayedQuotes = async (symbols: StockSymbol): SafePromise<Record<StockSymbol, DelayedQuote>> => {
    const env = this.session.getEnvironment(QuotesEnvironment);
    const path = this.routePath(quotesDelayedRoutes.delayed);
    const url = this.URL(path, this.withUpstreamCredentials({ symbols }, { apikey: env.delayedQuoteKey }));
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
